export default {
  data: [],
  loading: false,
  visited: [],
};
